import script from "./my-steps-comment.vue?vue&type=script&setup=true&lang=js"
export * from "./my-steps-comment.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__